import ErrorBoundary from './container'
export default ErrorBoundary
